module.exports = __webpack_public_path__ + "img/detail-time.fd0039ca.svg";